import './scss/index.scss';
import { dcFactory } from 'dc';
import { DimmerSwitchComponent } from './js/dimmer-switch.component';
import './js/mobiledimmer-switch.component';

dcFactory.register(DimmerSwitchComponent);
